import React, { useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Link, useLocation } from "react-router-dom";

const FurlissimoHome = () => {
  const location = useLocation();

  // Scroll ke atas setiap kali halaman berubah
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  return (
    <div className="font-[Quicksand] text-gray-700 bg-gradient-to-br from-[#AEE2FF]/40 to-[#F5A19D]/30 scroll-smooth">
      {/* ===== HERO SECTION ===== */}
      <section
        className="relative w-full min-h-screen flex items-center"
        style={{
          backgroundImage: "url('/assets/images/bg1.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Overlay putih transparan */}
        <div className="absolute inset-0 bg-white/10"></div>

        {/* Wrapper max-width untuk konten */}
        <div className="relative z-10 w-full max-w-6xl mx-auto px-8 md:px-16">
          <div className="space-y-6 text-left">
            <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 drop-shadow">
              Furlissimo Grooming
            </h1>
            <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 drop-shadow">
              with a Touch of Love & Style
            </h2>

            <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
              At Furlissimo, every dog is treated like family — with gentle
              care,
              <br /> expert grooming, and stylish results.
            </p>

            <div className="flex gap-4">
              <a
                href="https://bookings.gettimely.com/furlissimoptyltd/bb/book"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#F5A19D] text-gray-900 font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-[#f28e88] transition inline-block"
              >
                Book Now
              </a>

              <a
                href="#services"
                className="bg-white text-gray-900 font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-gray-100 transition"
              >
                View Services
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ===== ABOUT SECTION ===== */}
      <section
        className="py-20 px-8 md:px-16 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/assets/images/bgcolor2.png')" }}
      >
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div className="bg-white px-10 py-8 md:px-14 md:py-10 rounded-2xl shadow">
              <h2 className="text-4xl font-bold mb-6 text-gray-800">
                Why Choose Us
              </h2>

              <p className="text-lg md:text-xl mb-5 leading-relaxed">
                At Furlissimo, we’re more than a grooming service — we’re a
                community of dog lovers dedicated to bringing out every pup’s
                best look and spirit.
              </p>

              <p className="text-lg md:text-xl mb-5 leading-relaxed">
                Our salon feels like a boutique café for pets — stylish,
                welcoming, and full of wagging tails. Each visit is a moment of
                comfort, confidence, and joy.
              </p>

              <p className="text-lg md:text-xl leading-relaxed">
                If you have any questions, feel free to contact Rhylee at{" "}
                <a
                  href="mailto:admin@furlissimo.com.au"
                  className="text-[#F5A19D] font-medium hover:underline"
                >
                  admin@furlissimo.com.au
                </a>
              </p>
            </div>

            <div className="flex justify-center">
              <img
                src="/assets/images/image1.png"
                alt="Furlissimo team with dogs"
                className="rounded-2xl shadow-lg object-cover w-full max-w-md"
              />
            </div>
          </div>

          {/* Stats Cards */}
          <div className="grid md:grid-cols-4 gap-8 mt-20 text-center">
            {[
              {
                icon: "fa-scissors",
                value: "6+",
                text: "Years of Professional",
              },
              { icon: "fa-award", value: "5+", text: "Certified Groomers" },
              { icon: "fa-heart", value: "100%", text: "Tailored Care" },
              { icon: "fa-paw", value: "", text: "Apprenticeship Support" },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white p-10 rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col items-center"
              >
                <i
                  className={`fa-solid ${item.icon} text-5xl text-[#03BFD7] mb-5`}
                ></i>

                {/* Kalau value kosong, beri jarak */}
                {item.value ? (
                  <h3 className="text-4xl font-extrabold text-[#03BFD7] mb-2">
                    {item.value}
                  </h3>
                ) : (
                  <div className="h-10"></div> // ← spacer untuk card kosong
                )}

                <p className="text-gray-800 font-semibold text-lg md:text-xl">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FAQ ===== */}
      <section
        className="w-full bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/assets/images/bgcolor2.png')" }}
      >
        <div className="max-w-6xl mx-auto">
          {/* Ubah proporsi kolom grid di sini */}
          <div className="grid md:grid-cols-[40%_60%] gap-0 items-stretch">
            {/* Kolom Gambar */}
            <div className="flex">
              <img
                src="/assets/images/bg2.png"
                alt="Dog grooming"
                className="w-full h-full object-fill"
              />
            </div>

            {/* Kolom Konten */}
            <div className="bg-white w-full h-full">
              <div className="p-10 md:p-14">
                {/* Section 1 */}
                <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                  How often should my dog be groomed?
                </h3>
                <p className="text-lg leading-relaxed mb-8">
                  Short-haired dogs need grooming every 6–8 weeks, while long or
                  curly coats every 4–6 weeks. Our groomers will set a plan to
                  keep your dog clean and healthy.
                </p>

                {/* Section 2 */}
                <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                  What should I do between grooms?
                </h3>
                <ul className="list-disc list-inside text-lg leading-relaxed mb-8 text-gray-700 space-y-1">
                  <li>Brush a few times a week</li>
                  <li>Bathe every few weeks with dog-safe shampoo</li>
                  <li>Trim, tidy, or blow-dry every 4–6 weeks</li>
                  <li>Add-ons: de-shedding, ear cleaning, nail trims</li>
                </ul>
                <p className="text-lg leading-relaxed mb-10">
                  Unsure what to use? Ask our team for at-home care tips.
                </p>

                {/* Section 3 */}
                <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                  Do you cater for anxious or senior dogs?
                </h3>
                <p className="text-lg leading-relaxed mb-3">
                  Yes — we use gentle, fear-free handling with quiet slots,
                  low-noise dryers, and breaks as needed.
                </p>
                <p className="text-lg leading-relaxed">
                  Comfort and trust come first — every visit is tailored to your
                  dog’s needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SERVICES SECTION ===== */}
      <section
        id="services"
        className="w-full h-full py-32 px-8 md:px-16 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/assets/images/bg3.png')",
          backgroundSize: "cover",
        }}
      >
        <div className="max-w-6xl mx-auto text-center space-y-6">
          <h2 className="text-4xl font-bold text-gray-800">
            Services – Dog Grooming
          </h2>

          {/* Bagian Grid */}
          <div className="flex flex-col items-center mt-10 space-y-10">
            {/* Baris pertama: 3 card */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
              {[
                {
                  icon: "fa-scissors",
                  title: "Comfort Clip / Shave",
                  desc: "Full-body trim, practical, low-maintenance.",
                },
                {
                  icon: "fa-dog",
                  title: "Fluff Cut / Breed Standard Cut",
                  desc: "Precision styling, show-look, signature style.",
                },
                {
                  icon: "fa-bath",
                  title: "Tidy-Up Groom",
                  desc: "Quick refresh — bath, dry, light trim.",
                },
              ].map((s, i) => (
                <div
                  key={i}
                  className="bg-white rounded-2xl p-8 shadow-md flex flex-col items-center transform transition-all duration-300 hover:scale-105 hover:-translate-y-2 hover:shadow-2xl hover:bg-[#FFF9F9]"
                >
                  <i
                    className={`fa-solid ${s.icon} text-5xl text-[#9DF1F5] mb-5`}
                  ></i>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-3">
                    {s.title}
                  </h3>
                  <p className="text-gray-700 text-lg">{s.desc}</p>
                </div>
              ))}
            </div>

            {/* Baris kedua: 2 card di tengah */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 justify-center">
              {[
                {
                  icon: "fa-paw",
                  title: "First Puppy Tidy",
                  desc: "First grooming for puppies, gentle and friendly.",
                },
                {
                  icon: "fa-shower",
                  title: "Bath & Blow Dry",
                  desc: "Deep clean, blow-dry, ear-clean, nail-trim.",
                },
              ].map((s, i) => (
                <div
                  key={i}
                  className="bg-white rounded-2xl p-8 shadow-md flex flex-col items-center transform transition-all duration-300 hover:scale-105 hover:-translate-y-2 hover:shadow-2xl hover:bg-[#FFF9F9]"
                >
                  <i
                    className={`fa-solid ${s.icon} text-5xl text-[#9DF1F5] mb-5`}
                  ></i>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-3">
                    {s.title}
                  </h3>
                  <p className="text-gray-700 text-lg">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ===== GALLERY / TESTIMONIAL ===== */}
      <section id="gallery" className="bg-[#9DF1F5] py-20 px-8 md:px-16">
        <div className="max-w-6xl mx-auto text-center space-y-8">
          <h2 className="text-4xl font-bold text-gray-800">
            Gallery & Testimonial
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">
            {[
              {
                name: "Dan",
                text: "Lovely to deal with and did a great job with my puppy. Highly recommend. Easy parking.",
                img: "/assets/images/image3.jpg",
              },
              {
                name: "Leanne",
                text: "Our mini Schnauzer loves going to daycare and grooming at Furlissimo. Very happy with the service!",
                img: "/assets/images/image4.jpg",
              },
              {
                name: "Mike",
                text: "Brilliant service. Rhylee has looked after our Cavoodle since he was a puppy and always provides a great cut.",
                img: "/assets/images/image5.jpg",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white/70 p-6 rounded-2xl shadow-lg hover:scale-105 transition-transform flex flex-col items-center"
              >
                <img
                  src={item.img}
                  alt={`Gallery ${i + 1}`}
                  className="rounded-2xl shadow-md w-full h-64 object-cover"
                />
                <p className="mt-3 font-bold text-xl text-gray-900">
                  – {item.name}
                </p>
                <p className="mt-2 text-gray-700 italic text-lg">
                  “{item.text}”
                </p>
              </div>
            ))}
          </div>

          <p className="text-gray-800 text-2xl font-semibold">
            Check out our{" "}
            <Link
              to="/feedback"
              className="text-blue-600 hover:text-blue-800 underline-offset-4 hover:underline transition-all"
            >
              Review
            </Link>
            !
          </p>
        </div>
      </section>

      {/* ===== CONTACT / VISIT ===== */}
      <section id="contact" className="bg-[#9DF1F5] py-1">
        {/* Wrapper max-width */}
        <div className="w-full max-w-6xl mx-auto px-8 md:px-16">
          <div className="flex flex-col md:flex-row items-start justify-between gap-12">
            {/* Google Maps */}
            <div className="w-full md:w-1/2">
              <iframe
                title="Studio Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2683.127308084727!2d115.81978731564659!3d-32.02873208121153!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a32a4f000000000%3A0x0000000000000000!2s579A%20Canning%20Highway%2C%20Alfred%20Cove%20WA%206154!5e0!3m2!1sen!2sid!4v1700000000000!5m2!1sen!2sid"
                width="100%"
                height="380"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                className="rounded-xl shadow-lg"
              />
            </div>

            {/* Contact Info */}
            <div className="w-full md:w-1/2 space-y-8 text-gray-800 text-lg md:text-xl leading-relaxed">
              <div>
                <h2 className="text-2xl font-bold mb-3 text-gray-900">
                  Our Studio
                </h2>
                <p>
                  579A Canning Highway, Alfred Cove WA
                  <br />
                  <span className="text-base text-gray-600">
                    (Rear entrance + parking via Canning Hwy or North Lake Road)
                  </span>
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-3 text-gray-900">
                  Contact
                </h2>
                <p>
                  <span className="text-gray-900">0455 316 209</span>
                  <br />
                  <span className="text-gray-900 font-normal">
                    admin@furlissimo.com.au
                  </span>
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-3 text-gray-900">
                  Opening Hours
                </h2>
                <p>Monday – Friday, 8 am – 5 pm</p>
                <p className="text-base text-gray-600">
                  Saturday – by request only, additional charges apply
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FurlissimoHome;
